import styled, { keyframes } from 'styled-components';

export const Heading = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 16px;

  padding: 16px;

  button {
    width: 24px;
    height: 24px;

    background: none;
    border: none;
  }

  h2 {
    font-weight: 700;
    font-size: 16px;

    color: #1b1c1d;
  }
`;

export const Form = styled.form`
  width: 100%;
  height: calc(100dvh - 84px);
  overflow: scroll;

  display: flex;
  align-items: center;
  flex-direction: column;

  fieldset {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    gap: 16px;

    border: 0;
    border-bottom: 1px solid #d0dade;
    padding: 16px;
  }
`;

export const Legend = styled.legend`
  width: 100%;

  display: grid;
  place-items: center;
  gap: 16px;

  padding-top: 16px;

  img {
    width: 30px;
    height: 26px;
  }

  span {
    display: grid;
    gap: 9px;
  }

  span p {
    font-weight: 500;
    font-size: 14px;
    text-align: center;

    color: #373f45;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  gap: 16px;
`;

export const List = styled.ul`
  list-style: none;

  display: flex;
  flex-direction: column;
  gap: 13px;

  li {
    width: 100%;
  }

  h3 {
    font-weight: 500;
    font-size: 14px;

    color: #1b1c1d;
  }
`;

export const Annex = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  border: 1px solid #0274d2;
  border-radius: 8px;
  padding: 10px 15px;

  span {
    align-items: center;

    font-size: 12px;

    color: #0274d2;
  }

  span:first-child {
    width: 100%;
    display: grid;
    grid-template-columns: 28px 1fr;

    gap: 15px;

    font-weight: 500;

    p {
      width: 98%;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  span:last-child {
    display: grid;
    grid-template-columns: 43px 24px;
    gap: 10px;

    font-weight: 700;
    text-align: end;
  }

  img {
    max-width: 28px;
  }

  button {
    background: none;
    border: none;
  }
`;

export const Button = styled.button`
  width: calc(100% - 16px);

  margin: 16px 0 34px;
  border: 0;
  border-radius: 256px;
  padding: 15px 16px;

  font-weight: 700;
  font-size: 16px;

  color: #ffffff;
  background: #0059a4;

  transition: all 0.3s;

  &:disabled {
    cursor: not-allowed;

    color: #697177;
    background: #e6ebef;
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  margin: 0 auto;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${rotate} 2s linear infinite;
`;

export const Footer = styled.div`
  width: 100%;
  padding: 16px 24px;
`;
